import { render, staticRenderFns } from "./MioParentCertificates.vue?vue&type=template&id=93606cd8&"
import script from "./MioParentCertificates.vue?vue&type=script&lang=js&"
export * from "./MioParentCertificates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports